import 'date-fns';
import React, { FunctionComponent, useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';

type DatePickerProps = {
    label: string;
    value?: string;
    disableToolbar?: boolean;
    disabled?: boolean;
    fullWidth?: boolean | false;
    containerClasses?: string;
    datePickerClasses?: string;
    inputProps?: any;
    handleDate: Function;
    onInvalidDate?: Function;
    onBlur?: Function;
    onClose?: Function;
    onValidDate?: Function;
    minDate?: string;
    maxDate?: string;
    minDateMessage?: string;
    maxDateMessage?: string;
    marginNone?: boolean;
    error?: boolean;
};
const DatePicker: FunctionComponent<DatePickerProps> = (props) => {
    const {
        value,
        minDate,
        maxDate,
        minDateMessage,
        maxDateMessage,
        onInvalidDate,
        onValidDate,
        handleDate,
        onBlur,
        onClose,
        disabled,
    } = props;

    const [selectedDate, setSelectedDate] = useState<Date | null>(value ? moment(value).toDate() : null);

    useEffect(() => {
        if (!!!value) {
            setSelectedDate(null);
        } else {
            setSelectedDate(moment(value).toDate());
        }
    }, [value]);

    const handleDateChange = (date: Date | null) => {
        let dateToPass = '';

        if (date !== null) {
            dateToPass = moment(date).format('YYYY-MM-DD');
        }
        setSelectedDate(date);
        if (onInvalidDate && date?.toString() === 'Invalid Date') {
            onInvalidDate(() => {});
        }
        if (onValidDate) {
            onValidDate(() => {});
        }

        handleDate(dateToPass);
    };
    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid className={props.containerClasses} container justify="space-around">
                <KeyboardDatePicker
                    disableToolbar={props.disableToolbar || false}
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin={props.marginNone ? 'none' : undefined}
                    autoOk={true}
                    className={props.datePickerClasses}
                    label={props.label || null}
                    fullWidth={props.fullWidth}
                    value={selectedDate}
                    onChange={handleDateChange}
                    minDateMessage={minDateMessage}
                    maxDateMessage={maxDateMessage}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                    InputProps={props.inputProps}
                    minDate={minDate}
                    maxDate={maxDate}
                    onBlur={(e) => {
                        if (onBlur) onBlur(e);
                    }}
                    onClose={() => {
                        if (onClose) onClose(selectedDate);
                    }}
                    disabled={disabled}
                />
            </Grid>
        </MuiPickersUtilsProvider>
    );
};
export default DatePicker;
